import { render } from "./submit_booking.vue?vue&type=template&id=68da54ea"
import script from "./submit_booking.vue?vue&type=script&lang=js"
export * from "./submit_booking.vue?vue&type=script&lang=js"

import "./submit_booking.vue?vue&type=style&index=0&id=68da54ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__